<div class="main-content">
    <div class="container-fluid">

      <!-- <div class="row">
        <div class="summary-container">
         <div class="summary-card">
            <div class="card-title">Wallet Balance</div>
            <div class="card-content">
              <span class="amount">4567</span>
              <span class="currency">AED</span>
             <span class="change">+67</span>
            </div>
          </div> 
          <div class="summary-card">
            <div class="card-title">Today Transaction</div>
            <div class="card-content">
              <span class="amount">560</span>
              <span class="currency">AED</span>
             <span class="change">+25</span>
            </div>
          </div> 
          <div class="summary-card">
            <div class="card-title">Monthly Transaction</div>
            <div class="card-content">
              <span class="amount">45000</span>
              <span class="currency">AED</span>
             <span class="change">+1125</span>
            </div>
          </div> 
          <div class="summary-card">
            <div class="card-title">Monthly Refund</div>
            <div class="card-content">
              <span class="amount">1244</span>
              <span class="currency">AED</span>
             <span class="change">+120</span>
            </div>
          </div> 
        </div>
      </div> -->
 

        <!-- <div class="row">
            <div class="col-md-12">
                <div class="card ">
                    <div class="header">
                        <h4 class="title">Global Sales by Top Locations</h4>
                        <p class="category">All products that were shipped</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-5">
                                <lbd-table
                                  [data]="tableData">
                              </lbd-table>
                            </div>
                            <div class="col-md-6 col-md-offset-1">
                                <div id="worldMap" style="height: 300px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <br>
        <div class="row">
          <!-- <div class="col-md-4" >
            <lbd-chart
              [title]="'Email Statistics'"
              [subtitle]="'Last Campaign Performance'"
              [chartClass]="'ct-perfect-fourth'"
              [chartType]="emailChartType"
              [chartData]="emailChartData"
              [legendItems]="emailChartLegendItems"
              [withHr]="true"
              [footerIconClass]="'fa fa-clock-o'"
              [footerText]="'Campaign sent 2 days ago'">
            </lbd-chart>
          </div> -->

          <!-- <div class="col-md-8" >
            <lbd-chart
              [title]="'Users Behavior'"
              [subtitle]="'24 Hours performance'"
              [chartType]="hoursChartType"
              [chartData]="hoursChartData"
              [chartOptions]="hoursChartOptions"
              [chartResponsive]="hoursChartResponsive"
              [legendItems]="hoursChartLegendItems"
              [withHr]="true"
              [footerIconClass]="'fa fa-history'"
              [footerText]="'Updated 3 minutes ago'">
            </lbd-chart>
          </div> -->
        </div>

        <div class="row">
          <div class="col-md-6">
            <!-- <lbd-chart
              [title]="'2014 Sales'"
              [subtitle]="'All products including Taxes'"
              [chartType]="activityChartType"
              [chartData]="activityChartData"
              [chartOptions]="activityChartOptions"
              [chartResponsive]="activityChartResponsive"
              [legendItems]="activityChartLegendItems"
              [withHr]="true"
              [footerIconClass]="'fa fa-check'"
              [footerText]="'Data information certified'">
            </lbd-chart> -->
          </div>

          <!-- <div class="col-md-6" >
            <lbd-task-list
              [title]="'Tasks'"
              [subtitle]="'Backend development'"
              [tasks]="tasks"
              [withHr]="true"
              [footerIconClass]="'fa fa-history'"
              [footerText]="'Updated 3 minutes ago'">
            </lbd-task-list>
          </div> -->
        </div>

    </div>
</div>
